export const CyPlaylistFooterMenu = {
  ButtonAdd: "ButtonAdd",
} as const;
